module.exports = __webpack_public_path__ + "img/how__visual-1@2x.f9f1d174.jpg";